const dot=(a,b)=>a[0]*b[0]+a[1]*b[1]+a[2]*b[2];
const sub=(a,b)=>a.map((v,i)=>v-b[i]);
const cross=(a,b)=>[a[1]*b[2]-a[2]*b[1],a[2]*b[0]-a[0]*b[2],a[0]*b[1]-a[1]*b[0]];
export const normalize=v=>{const length=Math.hypot(...v)||1;return v.map(x=>x/length);};
export function triangleNormal(a,b,c){return normalize(cross(sub(b,a),sub(c,a)));}
export function rayTriangle(origin,direction,a,b,c){
 const edge1=sub(b,a),edge2=sub(c,a),p=cross(direction,edge2),det=dot(edge1,p);if(Math.abs(det)<1e-9)return null;
 const inv=1/det,t=sub(origin,a),u=dot(t,p)*inv;if(u<0||u>1)return null;
 const q=cross(t,edge1),v=dot(direction,q)*inv;if(v<0||u+v>1)return null;
 const distance=dot(edge2,q)*inv;return distance>=0?distance:null;
}
export function rayMesh(origin,direction,mesh){
 let nearest=null;const ids=mesh.indices||Array.from({length:mesh.positions.length/3},(_,i)=>i);
 for(let i=0;i<ids.length;i+=3){const points=[0,1,2].map(j=>Array.from(mesh.positions.slice(ids[i+j]*3,ids[i+j]*3+3))),distance=rayTriangle(origin,direction,...points);if(distance!==null&&(!nearest||distance<nearest.distance))nearest={distance,triangle:i/3,point:origin.map((v,j)=>v+direction[j]*distance)};}
 return nearest;
}
export function tangentNormal(normal,tangent,rgb,strength=1){
 const n=normalize(normal),t=normalize(tangent.slice(0,3)),b=cross(n,t).map(v=>v*(tangent[3]??1)),local=[(rgb[0]/255*2-1)*strength,(rgb[1]/255*2-1)*strength,rgb[2]/255*2-1];
 return normalize(n.map((v,i)=>t[i]*local[0]+b[i]*local[1]+v*local[2]));
}
export function rotatePoint(p,yaw,pitch){const x=p[0]*Math.cos(yaw)+p[2]*Math.sin(yaw),z=-p[0]*Math.sin(yaw)+p[2]*Math.cos(yaw);return [x,p[1]*Math.cos(pitch)-z*Math.sin(pitch),p[1]*Math.sin(pitch)+z*Math.cos(pitch)];}
export function projectPoint(p,yaw=0,pitch=0){const v=rotatePoint(p,yaw,pitch),scale=650/(4.8+v[2]);return [v[0]*scale,-v[1]*scale,v[2]];}
